import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { createTheme } from "@mui/material/styles";
import { SwipeableDrawer } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import AirplayIcon from "@mui/icons-material/Airplay";
import CallIcon from "@mui/icons-material/Call";
import Divider from "@mui/material/Divider";
import { useLocation } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";
import "../Styles/Navbar.css";

const theme = createTheme();

theme.typography.h3 = {
  fontFamily: "Permanent Marker, cursive",
  fontSize: "2rem",
};

export const NavBar = () => {
  
  const [anchor, setAnchor] = useState(false);
  const location = useLocation();
  console.log(location.hash);

  

  const toggleDrawer = (value) => {
    setAnchor(value);
  };

  return (
    <>
      <Box sx={{ flexGrow: 1 }} className="navbar">
        <AppBar position="fixed" color="default" k>
          <Toolbar>
            <IconButton
              sx={{
                display: { xs: "block", lg: "none", xl: "none", md: "none" },
              }}
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <SwipeableDrawer
              sx={{ padding: "50px" }}
              anchor="left"
              open={anchor}
              onClose={() => toggleDrawer(false)}
              onOpen={() => toggleDrawer(true)}
            >
              {
                <Box
                  sx={{
                    width: 250,
                  }}
                  onClick={() => toggleDrawer(false)}
                  onKeyDown={() => toggleDrawer(false)}
                >
                  <Typography
                    theme={theme}
                    variant="h3"
                    component="div"
                    sx={{ flexGrow: 1, margin: "0 0 0 20px" }}
                  >
                    Aditya
                  </Typography>
                  <Divider />
                  <div className="side-link">
                    <HomeIcon />
                    <Link className="link" smooth to="#home">
                      Home
                    </Link>
                  </div>
                  <Divider />
                  <div className="side-link">
                    <AccountCircleIcon />
                    <Link className="link" smooth to="#about">
                      About
                    </Link>
                  </div>
                  <Divider />
                  <div className="side-link">
                    <BuildCircleIcon />
                    <Link className="link" smooth to="#skills">
                      Skills
                    </Link>
                  </div>
                  <Divider />
                  <div className="side-link">
                    <AirplayIcon />
                    <Link className="link" smooth to="#projects">
                      Projects
                    </Link>
                  </div>
                  <Divider />
                  <div className="side-link">
                    <CallIcon />
                    <Link className="link" smooth to="#contact">
                      Contact
                    </Link>
                  </div>
                </Box>
              }
            </SwipeableDrawer>
            <Typography
              theme={theme}
              variant="h3"
              component="div"
              sx={{ flexGrow: 1 }}
            >
              Aditya Kumar
            </Typography>
            {/* <Tabs
              value={value}
              sx={{
                display: { xs: "none", lg: "block", xl: "block", md: "block" },
              }}
              onChange={handleChange}
              textColor="inherit"
              aria-label="secondary tabs example"
            >
                <Tab href="#home" value="home" label="Home"  />
                <Tab href="#about" value="about" label="About"  /> 
                <Tab href="#skills" value="skills" label="Skills" />              
                <Tab href="#projects" value="projects" label="Projects"/>
                <Tab href="#contact" value="contact" label="Contact"  />
                
              
            </Tabs> */}
            <div className="links">
              <Link className="link" smooth to="#home">
                Home
              </Link>
              <Link className="link" smooth to="#about">
                About
              </Link>
              <Link className="link" smooth to="#skills">
                Skills
              </Link>
              <Link className="link" smooth to="#projects">
                Projects
              </Link>
              <Link className="link" smooth to="#contact">
                Contact
              </Link>
            </div>
          </Toolbar>
        </AppBar>
      </Box>
    </>
  );
};
